/**
 * Whether this browser has met the game before — gates the first-run intro
 * (ui/IntroSequence.js). The same best-effort localStorage pattern as
 * MissionRecords / UserSettings: a disabled or full store degrades to "new",
 * which at worst replays a skippable intro.
 *
 * The flag is set when the player is plainly past the tutorial: completing
 * FT-101, or leaving a mission via Exit to Menu (App). Closing the tab mid-way
 * through FT-101 leaves it unset, so the next visit opens on the intro again.
 */

// Versioned so the meaning can change later without colliding with old data.
const STORAGE_KEY = 'flightSim.introSeen.v1';

/** True when the intro should play: never seen here, or `?intro` in the URL. */
export function shouldPlayIntro() {
  try {
    if (new URLSearchParams(location.search).has('intro')) return true;
    return localStorage.getItem(STORAGE_KEY) == null;
  } catch {
    return true;
  }
}

/** The player is no longer new — skip the intro on later visits. */
export function markIntroSeen() {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Storage disabled (private mode) or full — persistence is best-effort.
  }
}

/** Forget the flag (Settings → Data wipe), so the next boot is a first run. */
export function clearIntroSeen() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing persisted / storage unavailable — nothing to clear.
  }
}
